import apiClient from "../helper/apiClient";
import { get } from "lodash";
import { validateUserKey } from "./validateUserKey";

export default async function getTopicsData(requestObject) {
  validateUserKey(requestObject.userKey);
  try {
    const { data } = await apiClient.get("api/getTopicsByContext", {
      params: requestObject,
    });
    const topicsData = get(data, "data", []);
    return topicsData;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
